import { ReceiptTemplate, ReceiptItem } from '@baemingo/receipt';
import { CardDetails } from '~reducers';
import { TranslatedString } from '~Types';
import { getVenue_venue_receiptTemplate as VenueReceiptTemplate } from './__queries__';

export type Payment = { type: string; amount: string };

export enum ReceiptType {
  Sale = 'sale',
  Copy = 'copy',
  Refund = 'refund',
  Cheque = 'cheque',
  Invoice = 'invoice',
  TipRefund = 'tip_refund',
}

export interface Vars {
  [key: string]: string | undefined;
}

export type GenerateTemplateProps = (props: {
  type: ReceiptType;
  payments?: Payment[];
  cardDetails?: CardDetails;
  vars: Vars;
  isTable?: boolean;
  receiptTemplate: VenueReceiptTemplate;
  isTypeInvoice: boolean;
  items: ReceiptItem[];
  i18n: (obj: TranslatedString | string | null) => string;
  isCopy?: boolean;
  country?: string;
  showTipSuggestions?: boolean;
}) => ReceiptTemplate;
